"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockDeleteNotification = exports.mockHasNewNotifications = exports.mockNotifications = void 0;
exports.mockNotifications = {
    success: true,
    total: 3,
    err: '',
    notifications: [
        {
            _id: '63871fdba1ed0ee5b7a10885',
            type: 'News',
            title: 'Updates for Admin Users!!',
            description: '<h3>Updates for Admin Users important update for all admins!!</h3><ul><li>New "Communications Hub" for Admins, to allow sending email templates for users:</li></ul><p style="padding-left: 40px;">Templates are preset email structures and a great way to communicate the details of a Codebashing assignment to your developer team. You may choose to use your own custom template or a default one. Templates are especially helpful if you reuse or repeatedly send the same or similar assignments.</p><p style="padding-left: 40px;">Read more about this feature here: <a href="https://checkmarx.com/resource/documents/en/34965-153390-communication-templates-in-codebashing.html">Communications Hub</a></p><p style="padding-left: 40px;">This feature is available in General Availability.&nbsp;</p><p style="padding-left: 40px;">&nbsp;</p><p style="padding-left: 40px;"></p><h3>New Lessons Available For Developers</h3><ul><li>CSRF</li></ul><p style="padding-left: 40px;">Would you like to learn how to protect your web applications against CSRF attacks? Then, our CSRF course is the perfect resource for you! In this lesson, you will understand how CSRF attacks work and learn about practical approaches for protecting against them. From synchronizer tokens to cookie-to-header, youll explore various techniques for defending your application against malicious actors. Well also cover inadequate approaches to CSRF protection and explain how to implement a defense-in-depth strategy to safeguard your web application. Take advantage of this essential lesson for any web developer or security professional!</p><ul><li>SAMESITE COOKIE ATTRIBUTE</li></ul><p style="padding-left: 40px;"><span class="ui-provider gp b c d e f g h i j k l m n o p q r s t u v w x y z ab ac ae af ag ah ai aj ak" dir="ltr">We have added a new lesson: SameSite Cookie Attribution, to our "Front End Security Basics" course. In this lesson, you will learn what defines a SameSite Cookie Attribution, its three states, its risks, and its values. Most importantly, you will learn how you can prevent these risks in your application.</span></p><ul><li>"Cryptographic Failures," in which you will learn how incorrect use of cryptography or a lack thereof might lead to vulnerabilities such as sensitive data exposure.</li></ul><p>&nbsp;</p><ul><li>"Insecure Design," in which you will learn about its possible risks and how to prevent them.<br /><br /></li></ul>',
            publishedAt: '2022-11-30T09:18:09.522Z',
            createdAt: '2022-11-30T09:18:19.051+00:00',
            updatedAt: '2022-11-30T09:18:19.051+00:00',
            tenant: 'test',
        },
        {
            _id: '63871fdba1ed0ee5b7a108867',
            type: 'News',
            title: 'Updates for Admin Users!!',
            description: '<p>This is test 2 news! really exited news !!! really really!!!!! dedejk dejkdjek kjdek</p><p>&nbsp;</p><p><img src="https://codebashing-dev-content.s3-eu-west-1.amazonaws.com/courses-assets/course_logo_iac.svg" alt="Cloud" width="171" height="171" /></p>',
            publishedAt: '2022-11-30T09:18:09.522Z',
            createdAt: '2022-11-30T09:18:19.051+00:00',
            updatedAt: '2022-11-30T09:18:19.051+00:00',
            tenant: 'test',
        },
        {
            _id: '63871fdba1ed0ee5b7a108861',
            type: 'News',
            title: 'Updates for Admin Users!!',
            description: '<p>This is test 2 news! really exited news !!! really really!!!!! dedejk dejkdjek kjdek</p><p>&nbsp;</p><p><img src="https://codebashing-dev-content.s3-eu-west-1.amazonaws.com/courses-assets/course_logo_iac.svg" alt="Cloud" width="171" height="171" /></p>',
            publishedAt: '2022-11-30T09:18:09.522Z',
            createdAt: '2022-11-30T09:18:19.051+00:00',
            updatedAt: '2022-11-30T09:18:19.051+00:00',
            tenant: 'test',
        },
        {
            _id: '63871fdba1ed0ee5b7a108862',
            type: 'News',
            title: 'Updates for Admin Users!!',
            description: '<p>This is test 2 news! really exited news !!! really really!!!!! dedejk dejkdjek kjdek</p><p>&nbsp;</p><p><img src="https://codebashing-dev-content.s3-eu-west-1.amazonaws.com/courses-assets/course_logo_iac.svg" alt="Cloud" width="171" height="171" /></p>',
            publishedAt: '2022-11-30T09:18:09.522Z',
            createdAt: '2022-11-30T09:18:19.051+00:00',
            updatedAt: '2022-11-30T09:18:19.051+00:00',
            tenant: 'test',
        },
        {
            _id: '63871fdba1ed0ee5b7a108863',
            type: 'News',
            title: 'Updates for Admin Users!!',
            description: '<p>This is test 2 news! really exited news !!! really really!!!!! dedejk dejkdjek kjdek</p><p>&nbsp;</p><p><img src="https://codebashing-dev-content.s3-eu-west-1.amazonaws.com/courses-assets/course_logo_iac.svg" alt="Cloud" width="171" height="171" /></p>',
            publishedAt: '2022-11-30T09:18:09.522Z',
            createdAt: '2022-11-30T09:18:19.051+00:00',
            updatedAt: '2022-11-30T09:18:19.051+00:00',
            tenant: 'test',
        },
        {
            _id: '63871fdba1ed0ee5b7a108864',
            type: 'News',
            title: 'Updates for Admin Users!!',
            description: '<p>This is test 2 news! really exited news !!! really really!!!!! dedejk dejkdjek kjdek</p><p>&nbsp;</p><p><img src="https://codebashing-dev-content.s3-eu-west-1.amazonaws.com/courses-assets/course_logo_iac.svg" alt="Cloud" width="171" height="171" /></p>',
            publishedAt: '2022-11-30T09:18:09.522Z',
            createdAt: '2022-11-30T09:18:19.051+00:00',
            updatedAt: '2022-11-30T09:18:19.051+00:00',
            tenant: 'test',
        },
        {
            _id: '63871fdba1ed0ee5b7a108865',
            type: 'News',
            title: 'Updates for Admin Users!!',
            description: '<p>This is test 2 news! really exited news !!! really really!!!!! dedejk dejkdjek kjdek</p><p>&nbsp;</p><p><img src="https://codebashing-dev-content.s3-eu-west-1.amazonaws.com/courses-assets/course_logo_iac.svg" alt="Cloud" width="171" height="171" /></p>',
            publishedAt: '2022-11-30T09:18:09.522Z',
            createdAt: '2022-11-30T09:18:19.051+00:00',
            updatedAt: '2022-11-30T09:18:19.051+00:00',
            tenant: 'test',
        },
        {
            _id: '63871fdba1ed0ee5b7a108866',
            type: 'News',
            title: 'Updates for Admin Users!!',
            description: '<p>This is test 2 news! really exited news !!! really really!!!!! dedejk dejkdjek kjdek</p><p>&nbsp;</p><p><img src="https://codebashing-dev-content.s3-eu-west-1.amazonaws.com/courses-assets/course_logo_iac.svg" alt="Cloud" width="171" height="171" /></p>',
            publishedAt: '2022-11-30T09:18:09.522Z',
            createdAt: '2022-11-30T09:18:19.051+00:00',
            updatedAt: '2022-11-30T09:18:19.051+00:00',
            tenant: 'test',
        },
    ],
};
exports.mockHasNewNotifications = {
    success: true,
    hasNew: true,
};
exports.mockDeleteNotification = {
    success: true,
    dismissedId: 666,
};
